import { API_BASE_URL } from '../config/api';
import { publicUrl } from '../config/hosts';
import React, { useState, useEffect } from 'react';

interface VersionInfo {
  serverVersion: string;
  clientVersion: string;
  environment: string;
  timestamp: string;
}

const Footer: React.FC = () => {
  const [versionInfo, setVersionInfo] = useState<VersionInfo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVersionInfo = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/version`);
        if (response.ok) {
          const data = await response.json();
          setVersionInfo(data);
        }
      } catch (error) {
        console.error('Failed to fetch version info:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchVersionInfo();
  }, []);

  return (
    <footer className="footer mt-auto py-3 bg-light border-top">
      <div className="container">
        <div className="row align-items-center gy-2">
          <div className="col-12 col-md-8">
            <div className="footer-links d-flex flex-wrap align-items-center gap-2">
              Public Links: 
              <a 
                href={publicUrl('/releases')} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted"
              >
                Releases
              </a>
              <span className="text-muted">|</span>
              <a
                href={publicUrl('/mobile-app')}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted"
              >
                Mobile App
              </a>
              <span className="text-muted">|</span>
              <a 
                href={publicUrl('/download')} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted"
              >
                Firmware Download
              </a>
              <span className="text-muted">|</span>
              <a 
                href={publicUrl('/legacy')} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted"
              >
                Legacy Firmware Download
              </a>
            </div>
          </div>
          <div className="col-12 col-md-4 text-md-end">
            {loading ? (
              <span className="text-muted">Loading version...</span>
            ) : versionInfo ? (
              <span className="text-muted">
                Server: v{versionInfo.serverVersion}
              </span>
            ) : (
              <span className="text-muted">Version unavailable</span>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 